module.exports = __webpack_public_path__ + "static/media/check1.ce2e6439.jpg";